import { AssetJson } from 'models/assets/dto';
import { AssetGroup } from 'models/assetsGroups/dto';
import { DataTypeItem } from 'models/dataTypes/dto';
import {
	EventParams,
	EventFromParam,
	EventSeverityParam,
	EventResourceTypeParam,
} from 'models/eventsV2/model';
import { KafkaTopicItem } from 'models/kafkaTopics/dto';
import { NamespaceLabel } from 'models/namespaces/dto';
import { PolicyItem } from 'models/policiesV2/dto';
import { S3BucketItem } from 'models/s3Buckets/dto';
import { ProtocolValue } from './ProtocolFilter';

type FilterValues = {
	assets: AssetJson['name'][];
	clusters: AssetJson['cluster_id'][];
	clustersInternal: AssetJson['cluster_id'][];
	clustersExternal: AssetJson['cluster_id'][];
	dataTypes: DataTypeItem['id'][];
	dataTypesAll: DataTypeItem['id'][];
	eventType: EventParams['type'];
	eventTypeV2: EventParams['type'];
	eventStart: EventFromParam;
	groups: AssetGroup['id'][];
	kafkaInstances: KafkaTopicItem['instance_id'][];
	labelKeys: AssetJson['labels'][number]['key'][];
	labelValues: AssetJson['labels'][number]['value'][];
	namespaceLabelKeys: NamespaceLabel['key'][];
	namespaceLabelValues: NamespaceLabel['value'][];
	policyType: PolicyItem['type'] | '';
	protocol: ProtocolValue;
	tags: PolicyItem['tags'];
	namespaces: AssetJson['namespace'][];
	namespacesEndpoints: AssetJson['namespace'][];
	regions: S3BucketItem['region'][];
	resourceType: EventResourceTypeParam;
	resourceTypes: EventResourceTypeParam[];
	s3regions: S3BucketItem['region'][];
	severity: EventSeverityParam;
};

type FilterType = keyof FilterValues;

const defaultValues: FilterValues = {
	assets: [],
	clusters: [],
	clustersInternal: [],
	clustersExternal: [],
	dataTypes: [],
	dataTypesAll: [],
	eventType: '',
	eventTypeV2: '',
	eventStart: '90',
	groups: [],
	kafkaInstances: [],
	labelKeys: [],
	labelValues: [],
	namespaceLabelKeys: [],
	namespaceLabelValues: [],
	policyType: '',
	protocol: '',
	tags: [],
	namespacesEndpoints: [],
	namespaces: [],
	regions: [],
	resourceType: '',
	resourceTypes: [],
	s3regions: [],
	severity: '',
};

type FilterPropsBase = {
	fixed?: boolean;
	resetFilter?: () => void;
	defaultOpen?: boolean;
	onClose?: () => void;
};

export { defaultValues };
export type { FilterType, FilterPropsBase, FilterValues };
